export default __webpack_public_path__ + "static/OVHcloud-office-084f6efdbcab9182d73467d8b16c2dc1.jpg";